import { tools } from "../data/appCatalog.js";
import { useI18n } from "../i18n.jsx";
import { assetPath } from "../lib/legacyPaths.js";
import { usePlus } from "../plus/PlusProvider.jsx";

export default function LevelHome({ level, navigate }) {
  const plus = usePlus();
  const { t } = useI18n();

  return (
    <section className="level-home">
      <div className="level-overview">
        <div>
          <p className="kicker">{t(level.workspaceKey, {}, `${level.label} workspace`)}</p>
          <h2>{t("levelHome.chooseTool")}</h2>
          <p>{t(level.descriptionKey, {}, level.description)}</p>
        </div>
        <span>{t("common.modules", { count: level.modules })}</span>
      </div>

      <div className="tool-launcher-grid">
        {level.tools.map((toolId) => {
          const tool = tools[toolId];
          return (
            <button
              className="tool-launcher-card"
              key={toolId}
              type="button"
              onClick={() => navigate(`/${level.id}/${toolId}`)}
              style={{
                "--tool-card-accent": tool.accent,
                "--tool-card-accent-strong": tool.accentStrong,
                "--tool-card-soft": tool.soft,
                "--tool-card-surface": tool.surface,
                "--tool-card-ring": tool.ring
              }}
            >
              <span className="tool-launcher-media">
                <img src={assetPath(level.cards[toolId])} alt="" />
              </span>
              <span className="tool-launcher-copy">
                <strong>{t(tool.labelKey, {}, tool.label)}</strong>
                <span>{t(tool.launcherTextKey, {}, tool.launcherText)}</span>
                <small>{t(tool.launcherPointsKey, {}, tool.launcherPoints.join(" / "))}</small>
                {!plus.isPlus && toolId === "vocabulary" ? <span className="tool-launcher-note">{t("levelHome.vocabBurstNote")}</span> : null}
                {!plus.isPlus && toolId === "pronunciation" ? <span className="tool-launcher-note">{t("levelHome.premiumVoiceNote")}</span> : null}
              </span>
              <span className="tool-launcher-action">{t("common.open")}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
}
